import { useMemo, useState } from "react";
import Context from "./Context";

interface ContextProviderProps {
    children: React.ReactNode;
}

function ContextProvider({ children }: ContextProviderProps) {
    const [acessToken, setAcessToken] = useState("");
    const [validToken, setValidToken] = useState(false);
    const [openMenu, setOpenMenu] = useState(false);
    const acessTokneProviderValue = useMemo(
        () => ({
            acessToken,
            setAcessToken,
            validToken,
            setValidToken,
            openMenu,
            setOpenMenu,
        }),
        [
            acessToken,
            setAcessToken,
            validToken,
            setValidToken,
            openMenu,
            setOpenMenu,
        ]
    );
    return (
        <Context.Provider value={acessTokneProviderValue}>
            {children}
        </Context.Provider>
    );
}

export default ContextProvider;
